export const contactFormInitialValue = {
  userFirstName: "",
  userLastName: "",
  userPhone: "",
  userEmail: "",
};

export const organisationFormInitialValue = {
  organisationName: "",
  abn: "",
  tradingName: "",
  address: "",
  suburb: "",
  state: "",
  postcode: "",
  country: "",
  timeZone: ""
};